var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('quill-editor',{ref:"myQuillEditor",style:(_vm.height ? `height:${_vm.height}px` : ''),attrs:{"options":_vm.editorOption},model:{value:(_vm.contentStr),callback:function ($$v) {_vm.contentStr=$$v},expression:"contentStr"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }